var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99206 6.91012C8.94972 6.67687 8.74557 6.49999 8.50011 6.49999C8.22397 6.49999 8.00011 6.72385 8.00011 6.99999V11.5021L8.00817 11.592C8.05051 11.8253 8.25465 12.0021 8.50011 12.0021C8.77626 12.0021 9.00011 11.7783 9.00011 11.5021V6.99999L8.99206 6.91012ZM9.29883 4.74999C9.29883 4.33578 8.96304 3.99999 8.54883 3.99999C8.13461 3.99999 7.79883 4.33578 7.79883 4.74999C7.79883 5.16421 8.13461 5.49999 8.54883 5.49999C8.96304 5.49999 9.29883 5.16421 9.29883 4.74999ZM16.5 8C16.5 3.58172 12.9183 0 8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16C12.9183 16 16.5 12.4183 16.5 8ZM1.5 8C1.5 4.13401 4.63401 1 8.5 1C12.366 1 15.5 4.13401 15.5 8C15.5 11.866 12.366 15 8.5 15C4.63401 15 1.5 11.866 1.5 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircled);
export default __webpack_public_path__ + "static/media/exclamation-circled.05c68e61.svg";
export { ForwardRef as ReactComponent };